import { Pipe, PipeTransform } from '@angular/core';
import { UserLike } from '../services/avatar.service';

@Pipe({
  name: 'avatarType',
  standalone: true,
  pure: true,
})
export class AvatarTypePipe implements PipeTransform {
  transform(user: UserLike): 'image' | 'svg' {
    if (user?.['avatar_url']) return 'image';
    return 'svg';
  }
}
